module.exports = __webpack_public_path__ + "static/plataformaWebFlynow-956772e5fa1c8673da1565c655eab163.png";